import { convertToDecimals, ILogos, IPharmacistWorkshiftList, ServiceTypes, TimeFormat } from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import { configBuilder } from '../Admin/AvailableWorkshifts/helpers';

const isSelfService = ServiceHandler.getService() === ServiceTypes.self;

export enum WorkshiftListSortOption {
  rating = 'rating',
  hourlyRate = 'hourlyRate',
  distance = 'distance',
  shiftType = 'shiftType',
}

const getSortableNumber = (value?: number, fallback = 0) =>
  value ?? fallback;

export const pharmacistWorkshiftListBuilder = (
  event: Array<IPharmacistWorkshiftList>,
  allLogos: Array<ILogos>,
  timeFormat: TimeFormat,
) =>
  event.map((item) => {
    const {
      name,
      hourlyRate,
      logoId,
      startDate,
      endDate,
      city,
      workshiftId,
      pharmacyId,
      pharmacyRating,
      distance,
      softwareName,
      replacementType,
      longTermShiftContractId,
      isAutoSyncRecord,
      contractEndDate,
      contractStartDate,
      weekDayHourlyRate,
      weekendHourlyRate,
      isInWatchlist,
    } = item;

    const avatar = allLogos.find((logo) =>
      logo.logoId === logoId)?.image;

    return {
      config: configBuilder({
        startDate,
        endDate,
        timeFormat,
        city: isSelfService ? city : '',
        software: softwareName,
      }),
      hourlyRate: convertToDecimals(hourlyRate) as number,
      title: isSelfService && !isAutoSyncRecord ? name : city,
      avatar,
      workshiftId,
      pharmacyId,
      startDate,
      endDate,
      pharmacyRating,
      distance,
      softwareName,
      replacementType,
      longTermShiftContractId,
      isAutoSyncRecord,
      contractEndDate,
      weekDayHourlyRate,
      weekendHourlyRate,
      contractStartDate,
      isInWatchlist,
    };
  });

type WorkshiftListItem = ReturnType<typeof pharmacistWorkshiftListBuilder>[number];

export const sortWorkshiftList = (
  events: Array<WorkshiftListItem>,
  sortBy: WorkshiftListSortOption | '',
) => {
  const sortedEvents = [...events];

  switch (sortBy) {
    case WorkshiftListSortOption.rating:
      return sortedEvents.sort((a, b) =>
        getSortableNumber(b.pharmacyRating) - getSortableNumber(a.pharmacyRating));
    case WorkshiftListSortOption.hourlyRate:
      return sortedEvents.sort((a, b) =>
        getSortableNumber(b.hourlyRate) - getSortableNumber(a.hourlyRate));
    case WorkshiftListSortOption.distance:
      return sortedEvents.sort((a, b) =>
        getSortableNumber(a.distance, Number.POSITIVE_INFINITY)
        - getSortableNumber(b.distance, Number.POSITIVE_INFINITY));
    case WorkshiftListSortOption.shiftType:
      return sortedEvents.sort((a, b) =>
        Number(!!a.longTermShiftContractId)
        - Number(!!b.longTermShiftContractId));
    default:
      return sortedEvents;
  }
};
